import styled from 'styled-components'
import { getRem } from 'styles/utils'

export const ProjectInfoStyled = styled.section`
  width: calc(100% + 12px);
  margin-left: -6px;
  padding: ${getRem(24)} 0 0 ${getRem(6)};
  border-top: 1px solid ${({ theme }) => theme.colors.gray20};
`
